module.exports = __webpack_public_path__ + "media/images/location-bottom-d6d866d7e9afb6f2ff45ff98c8915e48.jpg";